module.exports = __webpack_public_path__ + "img/card.3d4aa213.svg";